import { get as _get } from 'lodash';

export default (urlParams: Record<string, string>): string => {
    return _get(urlParams, ['websiteId']);
};
